export default "__VITE_ASSET__DXPvAPC3__"